/**
 * Article Interactions
 * Manages scroll-triggered product popup for mobile/tablet
 * Replaces previous FAB system
 */

class ArticleInteractions {
    constructor() {
        this.popup = null;
        this.overlay = null;
        this.triggerPoint = 0.1; // 10% scroll trigger
        this.hasTriggered = false;
        this.init();
    }

    init() {
        // Initialize if screen width is tablet or smaller (<= 1024px)
        if (window.innerWidth <= 1024) {
            this.createPopup();
            window.addEventListener('scroll', this.checkScroll.bind(this), { passive: true });

            // Re-check on resize
            window.addEventListener('resize', () => {
                if (window.innerWidth > 1024 && this.popup) {
                    this.popup.style.display = 'none';
                    if (this.overlay) this.overlay.style.display = 'none';
                } else if (window.innerWidth <= 1024 && this.popup) {
                    this.popup.style.display = 'flex';
                    if (this.overlay) this.overlay.style.display = 'block';
                }
            });
        }
    }

    createPopup() {
        // Find the product card in the sidebar to clone
        // We look for 'article-sidebar-product' which is common in the template
        const originalProduct = document.querySelector('.article-sidebar-product');

        // If no product found, abort
        if (!originalProduct) return;

        // Create Overlay
        const overlay = document.createElement('div');
        overlay.className = 'article-product-modal-overlay';
        overlay.onclick = () => this.hidePopup();
        document.body.appendChild(overlay);
        this.overlay = overlay;

        // Create Popup Container
        const popup = document.createElement('div');
        popup.className = 'article-product-popup';

        // Create close button
        const closeBtn = document.createElement('button');
        closeBtn.innerHTML = '✕';
        closeBtn.className = 'article-popup-close';
        closeBtn.setAttribute('aria-label', 'Close popup');
        closeBtn.onclick = () => this.hidePopup();

        // Clone content
        const content = originalProduct.cloneNode(true);

        popup.appendChild(closeBtn);
        popup.appendChild(content);
        document.body.appendChild(popup);

        this.popup = popup;
    }

    checkScroll() {
        // Stop if already triggered or no popup created
        if (this.hasTriggered || !this.popup) return;

        // Only trigger on mobile/tablet
        if (window.innerWidth > 1024) return;

        // Calculate scroll percentage of article content
        const article = document.querySelector('.article-content-main');

        // Fallback to body if article content class not found
        const targetElement = article || document.body;

        if (!targetElement) return;

        const rect = targetElement.getBoundingClientRect();
        const elementHeight = rect.height;
        const scrolledPastTop = -rect.top; // pixels scrolled past element top

        // Calculate progress (0.0 to 1.0)
        // We use a simplified check: if we've scrolled past 10% of the element's height
        // AND the element is actually in view (top is negative)
        if (scrolledPastTop > (elementHeight * this.triggerPoint)) {
            this.showPopup();
        }
    }

    showPopup() {
        if (this.popup && this.overlay) {
            this.popup.classList.add('is-visible');
            this.overlay.classList.add('is-visible');
            this.hasTriggered = true; // Only show once per session
        }
    }

    hidePopup() {
        if (this.popup && this.overlay) {
            this.popup.classList.remove('is-visible');
            this.overlay.classList.remove('is-visible');
        }
    }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new ArticleInteractions();
    });
} else {
    new ArticleInteractions();
}
